module.exports = __webpack_public_path__ + "img/inactive-29.4ab82682.svg";